import React from "react";

export default function MySQL_RAND() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_RAND</h1>
      <p>This is the MySQL_RAND component generated from the SQL JSON.</p>
    </div>
  );
}
